export default "__VITE_ASSET__CQ_TqgO4__"